import BasePolicy from '@/policies/BasePolicy.js';

export default class MeetingPolicy extends BasePolicy {
    /**
     * @param {User} user
     * @param {Number} courseId
     * @returns boolean
     */
    viewAny(user, courseId) {
        return user.hasPermissionTo('view all meetings') || user.isStudentSupportOfCourse(courseId);
    }

    /**
     * @param {User} user
     * @param {Meeting} meeting
     * @returns boolean
     */
    view(user, meeting) {
        return (
            user.hasPermissionViaCourseTo(meeting.course_id, 'view a meeting') ||
            user.isStudentSupportOfCourse(meeting.course_id)
        );
    }

    /**
     * @param {User} user
     * @param {Meeting} meeting
     * @returns boolean
     */
    viewDetails(user, meeting) {
        return (
            user.isInstructorOf(meeting.course_id) ||
            user.isGroupInstructorOf(meeting.course_id) ||
            user.isStudentSupportOfCourse(meeting.course_id)
        );
    }

    /**
     * @param {User} user
     * @param {Course} course
     * @returns boolean
     */
    create(user, course) {
        const permission = 'create a meeting';

        return user.hasPermissionTo(permission) || user.hasUnlimitedScopePermissionTo(permission);
    }

    /**
     * @param {User} user
     * @param {Meeting} meeting
     * @returns boolean
     */
    update(user, meeting) {
        return (
            user.hasPermissionViaCourseTo(meeting.course_id, 'edit a meeting') ||
            user.hasGroupPermissionWithinCourse(meeting.course_id, 'edit a meeting')
        );
    }

    /**
     * @param {User} user
     * @param {Meeting} meeting
     * @returns boolean
     */
    delete(user, meeting) {
        return (
            user.hasPermissionViaCourseTo(meeting.course_id, 'delete a meeting') ||
            user.hasGroupPermissionWithinCourse(meeting.course_id, 'delete a meeting')
        );
    }

    toggleRecordingVisibility(user, meeting) {
        return user.hasPermissionTo('hide all meeting recordings');
    }
}
